/** Pure mapping between an offline remeasure document and sketch.remeasure_sessions. */
import { deserializeRemeasureSession } from './remeasure-session.js';

const clean = (value) => String(value ?? '').trim();

export function remeasureSessionToRows(session, { ownerId, projectId, clientId = null } = {}) {
  const value = deserializeRemeasureSession(session);
  const sketch = value.originalSketch;
  return {
    project: {
      id: projectId,
      owner_id: ownerId,
      name: [clean(sketch.client), clean(sketch.opportunity)].filter(Boolean).join(' — ') || 'Untitled project',
      salesforce_opportunity_id: null,
      client_id: clientId,
    },
    remeasure: {
      id: value.id,
      project_id: projectId,
      room_id: value.sourceSketchId,
      source_sketch_id: value.sourceSketchId,
      status: value.status,
      technician: value.technician,
      original_snapshot: value.originalSketch,
      measurements: value.measurements,
      original_captured_at: value.originalCapturedAt,
      completed_at: value.completedAt,
      client_id: clientId,
      created_at: value.createdAt,
      updated_at: value.updatedAt,
      deleted_at: null,
    },
  };
}

export function rowToRemeasureSession(row) {
  return deserializeRemeasureSession({
    schemaVersion: 1,
    id: row.id,
    sourceSketchId: row.source_sketch_id,
    status: row.status,
    technician: row.technician ?? '',
    originalCapturedAt: row.original_captured_at,
    originalSketch: row.original_snapshot,
    measurements: row.measurements,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
    completedAt: row.completed_at,
  });
}
